import React from 'react';
import { DNAButton, DNAText } from '@alucio/lux-ui';
import DNAPopover from 'src/components/DNA/Popover/DNAPopover';
import { useSidebar } from '../SidebarProvider';
import { styles } from '..';

const DownloadButton: React.FC = () => {
  const { disPlayDownloadButton, onDownload } = useSidebar();

  if (!disPlayDownloadButton) return null;
  return (
    <DNAPopover placement="left" disablePopover={['tabletPWA']}>
      <DNAPopover.Anchor>
        <DNAButton
          appearance="ghost"
          status="tertiary"
          size="lg"
          iconLeft="download-simple"
          onPress={onDownload}
        />
      </DNAPopover.Anchor>
      <DNAPopover.Content>
        <DNAText style={styles.tooltipText} numberOfLines={1}>Download</DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export default DownloadButton;
